import { Button } from "@headlessui/react"

interface IFragNavButtonProps {
    text: string
    onClick: () => void
}

export const FragNavButton = (props: IFragNavButtonProps) => {
    return (
        <Button className={'md:text-2xl text-xl cursor-pointer'} onClick={props.onClick}>
            {props.text}
        </Button>
    )
}